export class AdminInviteModel {

    public email: string;
    public lastName: string;
    public firstName: string;
    public middleName: string;
    public organization: string;
    public greeting: string;

}


// WEBPACK FOOTER //
// ./src/app/core/models/adminInviteModel.model.ts